// extracted by mini-css-extract-plugin
export const flexColumn = "ref-module--flexColumn--1vlBc";
export const imageStar = "ref-module--imageStar--17MY1";
export const imageRef = "ref-module--imageRef--7IcLW";
export const imageWrapper = "ref-module--imageWrapper--1O6KD";
export const imageContainer = "ref-module--imageContainer--dTTyG";
export const title = "ref-module--title--2gJqC";
export const moreLink = "ref-module--moreLink--2VkPM";